import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';

class NavMenuUserDetails extends React.Component {

    render() {
        const workingTitle = this.props.user.workingTitle;

        return (
            <div className="user-details">
                <div className="user-info">
                    <h4 className="font-14 text-nowrap">{this.props.intl.formatMessage(messages.sideBarNavMenuTitle)}</h4>
                    {/*<h4 className="font-16">{this.props.user.name} {workingTitle ? `[${workingTitle}]` : ''}</h4>
                    <span className="text-muted user-status"><i className="fa fa-dot-circle-o text-success"></i> Online</span>*/}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {user: state.user};
};

export default injectIntl(connect(mapStateToProps)(NavMenuUserDetails));









// WEBPACK FOOTER //
// ./web/src/components/users/NavMenuUserDetails.jsx